import Box from 'shared_DEPRECATED/components/Box';
import Spacer from 'shared_DEPRECATED/components/Spacer';

import { Typography } from 'shared/components/Typography';

export const ChatMessageNewDelimiter = () => (
  <>
    <Box
      style={{
        position: 'relative',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <Box
        style={{
          position: 'absolute',
          top: '50%',
          bottom: '50%',
          left: 0,
          right: 0,
          height: '1px',
          backgroundColor: 'var(--bgCompPrimaryInverse)',
        }}
      />
      <Box
        style={{
          position: 'relative',
          zIndex: 1,
          backgroundColor: 'var(--bgSecondary)',
        }}
      >
        <Spacer size="md">
          <Typography type="small" color="black">
            New Messages
          </Typography>
        </Spacer>
      </Box>
    </Box>
  </>
);
